var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useForm } from '@inertiajs/react';
import classNames from 'classnames';
import { useRef } from 'react';
import { useRoute } from 'ziggy-js';
import JetActionMessage from '@/Jetstream/ActionMessage';
import JetButton from '@/Jetstream/Button';
import JetFormSection from '@/Jetstream/FormSection';
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError';
import JetLabel from '@/Jetstream/Label';
import { Ziggy } from "@/ziggy";
export default function UpdatePasswordForm() {
    var route = useRoute(Ziggy);
    var form = useForm({
        current_password: '',
        password: '',
        password_confirmation: '',
    });
    var passwordRef = useRef(null);
    var currentPasswordRef = useRef(null);
    function updatePassword() {
        form.put(route('user-password.update'), {
            errorBag: 'updatePassword',
            preserveScroll: true,
            onSuccess: function () { return form.reset(); },
            onError: function () {
                var _a, _b;
                if (form.errors.password) {
                    form.reset('password', 'password_confirmation');
                    (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }
                if (form.errors.current_password) {
                    form.reset('current_password');
                    (_b = currentPasswordRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                }
            },
        });
    }
    return (_jsxs(JetFormSection, __assign({ onSubmit: updatePassword, title: 'Update password', description: 'Ensure your account is using a long, random password to stay secure.', renderActions: function () { return (_jsxs(_Fragment, { children: [_jsx(JetActionMessage, __assign({ on: form.recentlySuccessful, className: "mr-3" }, { children: "Saved." })), _jsx(JetButton, __assign({ className: classNames({ 'opacity-25': form.processing }), disabled: form.processing }, { children: "Save" }))] })); } }, { children: [_jsxs("div", __assign({ className: "col-span-6 sm:col-span-4" }, { children: [_jsx(JetLabel, __assign({ htmlFor: "current_password" }, { children: "Current Password" })), _jsx(JetInput, { id: "current_password", type: "password", className: "mt-1 block w-full", ref: currentPasswordRef, value: form.data.current_password, onChange: function (e) {
                            return form.setData('current_password', e.currentTarget.value);
                        }, autoComplete: "current-password", "data-lpignore": "true" }), _jsx(JetInputError, { message: form.errors.current_password, className: "mt-2" })] })), _jsxs("div", __assign({ className: "col-span-6 sm:col-span-4" }, { children: [_jsx(JetLabel, __assign({ htmlFor: "password" }, { children: "New password" })), _jsx(JetInput, { id: "password", type: "password", className: "mt-1 block w-full", value: form.data.password, onChange: function (e) { return form.setData('password', e.currentTarget.value); }, autoComplete: "new-password", ref: passwordRef, "data-lpignore": "true" }), _jsx(JetInputError, { message: form.errors.password, className: "mt-2" })] })), _jsxs("div", __assign({ className: "col-span-6 sm:col-span-4" }, { children: [_jsx(JetLabel, __assign({ htmlFor: "password_confirmation" }, { children: "Confirm password" })), _jsx(JetInput, { id: "password_confirmation", type: "password", className: "mt-1 block w-full", value: form.data.password_confirmation, onChange: function (e) {
                            return form.setData('password_confirmation', e.currentTarget.value);
                        }, autoComplete: "new-password", "data-lpignore": "true" }), _jsx(JetInputError, { message: form.errors.password_confirmation, className: "mt-2" })] }))] })));
}
